import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

function Presentations({ presentations }) {
  return (
    <Fragment>
      <p className="presentations-list__title">Presentations: </p>
      <table className="presentations-list">
        <tbody>
          {presentations.map(presentation => (
            <tr key={presentation.id}>
              <td>
                <span className="text-regular">
                  {presentation.attributes.speaker}
                </span>
              </td>
              <td>
                <span>
                  {presentation.attributes.title}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Fragment>
  )
}

Presentations.propTypes = {
  presentations: PropTypes.array.isRequired,
}

export default Presentations
